module.exports = __webpack_public_path__ + "img/invoice-de-male-bw.309885e5.png";